import { get, post, deleteRequest } from './_defaults/fetch.js';

export const getAgents = ({params, config}) => get(`/agents`, {params, ...config});
export const getAgent = ({id, params, config}) => get(`/agents/${id}`, {params, ...config});
export const createAgent = ({data, config}) => post('/agents', data, config);
export const updateAgent = ({id, data, config}) => post(`/agents/${id}`, data, config);
export const deleteAgent = ({id, config}) => deleteRequest(`/agents/${id}`, null, config);

export const createAgentMcp = ({id, data, config}) => post(`/agents/${id}/mcps`, data, config);
export const deleteAgentMcp = ({id, mcpId, config}) => deleteRequest(`/agents/${id}/mcps/${mcpId}`, null, config);

export const createAgentArea = ({id, data, config}) => post(`/agents/${id}/areas`, data, config);
export const deleteAgentArea = ({id, areaId, config}) => deleteRequest(`/agents/${id}/areas/${areaId}`, null, config);

export const createAgentOffice = ({id, data, config}) => post(`/agents/${id}/offices`, data, config);
export const deleteAgentOffice = ({id, officeId, config}) => deleteRequest(`/agents/${id}/offices/${officeId}`, null, config);

export const createAgentTag = ({id, data, config}) => post(`/agents/${id}/tags`, data, config);
export const deleteAgentTag = ({id, tagId, config}) => deleteRequest(`/agents/${id}/tags/${tagId}`, null, config);